import LotDetails_BAPP from './CustomisedPages/LotDetails_BAPP';
import LotDetails_BRCP from './CustomisedPages/LotDetails_BRCP';
import LotDetails_BRCP_HoldingLot from './CustomisedPages/LotDetails_BRCP_HoldingLot';
import LotDetails_BRPO from './CustomisedPages/LotDetails_BRPO';
import LotDetails_BTBU from './CustomisedPages/LotDetails_BTBU';
import LotDetails_HCC from './CustomisedPages/LotDetails_HCC';
import LotDetails_SCP from './CustomisedPages/LotDetails_SCP';

/**
 * Lot Details selector provides the correct lot details component based on the inputed business unit
 * This allows each business unit to have their own customised lot details component
 */
export function LotDetailsSelector({ businessUnitCode, lotNumber }: { businessUnitCode: string; lotNumber: string; }) {
    switch (businessUnitCode) {
        case "BAPP_PP":
            return <LotDetails_BAPP />;
        case "BTBU":
            return <LotDetails_BTBU />;
        case "BRPO_HDPE":
        case "BRPO_PP1":
        case "BRPO_PP2":
            return <LotDetails_BRPO />;
        case "BRCP_HFU":
        case "BRCP_VFU":
            if (lotNumber.substring(lotNumber.length - 3, lotNumber.length - 1) === "00") {
                return <LotDetails_BRCP_HoldingLot />;
            } else {
                return <LotDetails_BRCP />;
            }
        case "HCC_PP":
        case "HCC_GPPE":
        case "HCC_LDPE":
            return <LotDetails_HCC />;
        case "SCP_PP":
        case "SCP_PE":
        case "SCP_SME":
            return <LotDetails_SCP />;
        default:
            return businessUnitCode ? <p>No LotDetails component defined for business unit {businessUnitCode}</p> : <></>;
    }
}
